// validação de campos compartilhados para bloquear ou não o botão

// Safras
export const safrasValidation = (ano, areaDestinada, dataInicio) => {
  const safrasIsValid = !ano || !areaDestinada || !dataInicio
  return safrasIsValid
}

// Previsão colheita e produtividade
export const previsaoColheitaValidation = (previsoesColheitaProdutividade) => {
  const previsoesColheitaIsValid = !Array.isArray(previsoesColheitaProdutividade) || previsoesColheitaProdutividade.length === 0
  return previsoesColheitaIsValid
}

// Bioinsumos
export const bioinsumosValidation = (utilizaBioinsumos, bioinsumos) => {
  const naoSelecionouUsoBioinsumo = utilizaBioinsumos === '' && !bioinsumos
  const usaBioinsumos = utilizaBioinsumos === true
  const bioinsumosInvalidos = !Array.isArray(bioinsumos) || bioinsumos.length === 0
  const existeOUTROSemEspecificacao = usaBioinsumos && Array.isArray(bioinsumos) &&
  bioinsumos.some(
    (item) => (item.tipo === 'OUTROS' && (!item.especificacao || item.especificacao.trim() === '')) ||
    (item.tipo === 'BIOFERTILIZANTES' && (!item.especificacao || item.especificacao.trim() === ''))
  )
  const bioinsumosIsValid = naoSelecionouUsoBioinsumo || (usaBioinsumos && (bioinsumosInvalidos || existeOUTROSemEspecificacao))
  return bioinsumosIsValid
}

// Irrigação
export const irrigacaoValidation = (possuiIrrigacao, irrigacao) => {
  const naoSelecionouUsoIrrigacao = possuiIrrigacao === ''
  const usaIrrigacao = possuiIrrigacao === true
  const areaIrrigada = irrigacao.area === 0 || !irrigacao.area
  const dataInicio = !irrigacao.dataInicio
  const captacaoLicenciada = !irrigacao.captacaoLicenciada

  const tiposSistemas = !Array.isArray(irrigacao.tiposSistemas) || irrigacao.tiposSistemas.length === 0 ||
    (irrigacao.tiposSistemas.includes('OUTRO') && (!irrigacao.outroSistema || irrigacao.outroSistema.trim() === ''))
  const fonteAguaUtilizada = !Array.isArray(irrigacao.fontesAgua) || irrigacao.fontesAgua.length === 0 ||
    (irrigacao.fontesAgua.includes('OUTRO') && (!irrigacao.outroFonteAgua || irrigacao.outroFonteAgua.trim() === ''))
  const irrigacaoIsValid = naoSelecionouUsoIrrigacao || (usaIrrigacao && (areaIrrigada || dataInicio || tiposSistemas || fonteAguaUtilizada || captacaoLicenciada))
  return irrigacaoIsValid
}

// Financiamentos
export const financiamentosValidation = (financiamentos, outroFinanciamento) => {
  const financiamentosIsValid = !Array.isArray(financiamentos) || financiamentos.length === 0 ||
  (financiamentos.includes('OUTRO') && (!outroFinanciamento || outroFinanciamento.trim() === ''))
  return financiamentosIsValid
}



// WEBPACK FOOTER //
// ./src/libs/utils/validations/praticasValidations.js